import { Box, Text } from '@chakra-ui/react';

interface MentionEmptyCardProps {
  title: string;
  description: string;
  /** A failed read tints the card so it reads as a problem, not just absence. */
  tone?: 'neutral' | 'error';
  'data-testid'?: string;
}

/**
 * The one empty/settled card of the mention pane, used wherever a block has
 * nothing honest to draw: the organic timeline before it has two points, a
 * failed timeline read, and a boost that has not produced figures yet.
 *
 * Deliberately flat — a title and one line inside a bordered card. It never
 * fabricates a shape (no ghost curve, no zeroed axis) so an empty block is
 * never mistaken for a real reading.
 */
export function MentionEmptyCard({
  title,
  description,
  tone = 'neutral',
  'data-testid': testId,
}: MentionEmptyCardProps) {
  const isError = tone === 'error';

  return (
    <Box
      border="1px solid"
      borderColor={isError ? 'red.200' : 'border'}
      rounded="lg"
      bg={isError ? 'red.50' : 'panelBg'}
      px={4}
      py={6}
      textAlign="center"
      data-testid={testId}
    >
      <Text fontSize="sm" fontWeight="medium" color={isError ? 'red.800' : 'gray.700'}>
        {title}
      </Text>
      <Text fontSize="xs" color={isError ? 'red.700' : 'fg.muted'} mt={1}>
        {description}
      </Text>
    </Box>
  );
}
